<template>
  <div
    class="FooterDesktop flex flex-col bg-qwray text-white text-10px xl:text-16px"
    style="grid-row: var(--footer-row);"
    :class="footerFixed ? 'fixed bottom-0 w-screen' : ''"
    :country="entity"
  >
    <div
      class="flex flex-row bg-qwray md:px-16 pt-10 justify-between items-center text-10px xl:text-16px footerPadding"
    >
      <div class="flex flex-col w-1/5 self-start logoWidth">
        <div class="flex flex-col items-start justify-start">
          <section class="Max">
            <div><img class="3xl:w-150px" src="~@/assets/logo.svg" /></div>
            <div class="text-white mt-2">{{ $t('slogan') }}</div>
          </section>
          <ChangeCountryOption :dispatch="dispatch" />
        </div>
      </div>
      <div class="footerItems flex flex-row">
        <footer-item-desktop
          v-for="(block, index) in linkBlocks"
          v-bind:name="block.name"
          v-bind:key="index"
          v-bind:links="block.links"
          v-bind:dispatch="dispatch"
          :class="index == 0 ? '' : 'lastElement'"
        ></footer-item-desktop>
      </div>
      <div class="logos-parent">
        <a
          style="height: max-content; flex: 1; align-self: center;"
          href="https://www.bdew.de/"
          ><img
            v-if="shouldDisplayLogo"
            class="image-logo"
            src="~@/assets/bdew-logo.svg"
            alt="BDEW Logo"
          />
        </a>
      </div>
      <div class="flex-col items-center self-start contact-parent">
        <div
          class="customer-title contact-title md:text-8px lg:text-12px xl:text-16px"
        >
          {{ $t('footer.available') }}
        </div>
        <div
          class="customer-phone contact-item text-qwray flex items-center md:text-8px lg:text-12px xl:text-16px py-1 px-4 mt-1 rounded-full cursor-pointer"
        >
          <img class="pr-2" src="~@/assets/footer/footer_phone.svg" />
          <a
            class="Phone"
            :href="
              `tel:${customerPhone
                .split(' ')
                .filter(Boolean)
                .join('')}`
            "
            >{{ customerPhone }}</a
          >
        </div>
        <span
          v-if="shouldShowBusinessNumber"
          style="margin-top: 1em;"
          class="contact-title md:text-8px lg:text-12px xl:text-16px"
          >{{ $t('footer.contact-title') }}</span
        >
        <div
          v-if="shouldShowBusinessNumber"
          class="contact-item text-qwray flex items-center md:text-8px lg:text-12px xl:text-16px py-1 px-4 mt-1 rounded-full cursor-pointer"
        >
          <img class="pr-2" src="~@/assets/footer/footer_phone.svg" />
          <a
            class="Phone"
            :href="
              `tel:${businessPhone
                .split(' ')
                .filter(Boolean)
                .join('')}`
            "
            >{{ businessPhone }}</a
          >
        </div>
      </div>
    </div>
    <hr style="border: #5E7177 1px solid; margin: 37px 0;" />
    <div
      class="flex flex-row justify-between items-center xl:px-24 lg:px-20 md:px-16 footerPadding footerBottom"
    >
      <div
        class="text-qwraybright text-center md:text-8px lg:text-12px xl:text-14px self-center pl-96px "
      >
        {{ $t('footer.copyright') }}
      </div>
    </div>
  </div>
</template>

<script>
import i18n from '@/i18n';
import linkBl from '@/data/footer';
import { entity } from '@/../region.json';
import FooterItemDesktop from './FooterItemDesktop.vue';
import ChangeCountryOption from '../components/shared/ChangeCountryOption.vue';
import matchEntities, {
  shouldShowBusinessNumber,
  getLinkBlocks,
} from '../shared/entityHelpers';

export default {
  name: 'FooterDesktop',
  props: ['dispatch'],
  components: {
    FooterItemDesktop,
    ChangeCountryOption,
  },
  data() {
    return {
      entity,
      linkBlocks: getLinkBlocks(linkBl, this.$i18n.locale),
      footerFixed: this.$route.meta.footerFixed,
      customerPhone: i18n.t('contact.support_phone'),
      businessPhone: i18n.t('footer.phone'),
    };
  },
  computed: {
    shouldDisplayLogo() {
      return matchEntities(['GERMANY']);
    },
    shouldShowBusinessNumber,
  },
  methods: {
    matchEntities,
  },
};
</script>

<style scoped>
.FooterDesktop[country='NETHERLANDS'] .customer-phone {
  display: none;
}
.FooterDesktop[country='NETHERLANDS'] .customer-title {
  display: none;
}
.logoWidth {
  width: min-content !important;
}
.footerBottom {
  margin-bottom: 32px;
}
.Max {
  width: max-content;
}
.Phone {
  white-space: nowrap;
}
.image-logo {
  width: 69px;
}
.logos-parent {
  display: flex;
  /* justify-content: space-evenly; */
}

.contact-parent {
  display: flex;
  text-align: center;
}
.contact-parent > * {
  width: 100%;
}
.contact-title {
  color: #a1b1b5;
}
.contact-item {
  border: 1px solid white;
  color: white;
  width: max-content;
}
@media (min-width: 1024px) {
  .footerPadding {
    padding-left: 140px;
    padding-right: 140px;
  }
}
@media (min-width: 1680px) {
  .footerPadding {
    padding-left: 200px;
    padding-right: 200px;
  }
}
</style>
